import {
  EAuctionType,
  EBrand,
  ELotStatus,
  LegacyDateValue,
  SaleResponseRelatedPressItem,
} from '@bonhams1793/bonhams-typescript'

import { SaleSection } from '@nx/global-types'

export interface LotResponse {
  artists: unknown
  brand: EBrand
  iSaleNo: LotResponseSaleNo
  iSaleLotNoUnique: number
  iSaleItemNo: number
  iSaleLotNo: number
  sSaleLotNoA: string
  iCompanyNo: number
  iClientNo: number
  lAddendum: boolean
  iSaleSectionNo: number
  lExhibition: boolean
  lNotForMarketing: boolean
  lNotPublishedResults: boolean
  lWithoutReserve: boolean
  lReferDept: boolean
  lUnderCopyright: boolean
  dLotLowValue: number
  dLotHighValue: number
  dEstimateLow: number
  dEstimateLowCur: number
  dEstimateLowCur3: number
  dEstimateHigh: number
  dEstimateHighCur: number
  dEstimateHighCur3: number
  dStartingBidAmt: number
  sReceiptDivision: string
  sLotStatus: ELotStatus
  sDesc: string
  sExtraDesc: string
  sStyledDesc: string
  sCatalogDesc: string
  footnote_sExtraDesc: string | null
  lNotPublishedOnWeb: boolean
  lPreviewLot: boolean
  sCurrencySymbol: string
  sCurrencySymbol2: string
  sCurrencySymbol3: string
  currency: {
    iso_code: string
    bonhams_code: string
  }
  dHammerPrice: number
  dHammerPremium: number
  rowid: string | null
  amsale_rowid: string
  shipping_quote_link: string
  images: LotResponseImage[]
  sale_info: LotResponseSaleInfo
  prev_next_lot: LotResponsePrevNextLot
  notices?: string | null
  sCondition?: string | null
  has_condition_report: boolean
  lot_symbols: {
    sShortDesc: string
    sLotSymbol: string
    sLongDesc: string
  }[]
  related_press: SaleResponseRelatedPressItem[]
  section: SaleSection
  people: number[]
  video_ids: string[]
  hammerTime: LegacyDateValue
  biddableFrom?: LegacyDateValue
}

export type PreviewLotResponse = LotResponse[]

export interface LotResponseSaleNo {
  iSaleNo: number
  sSaleName: string
  sSaleType: EAuctionType
  sDivision: string
  sDepartment: string
  sVenue: string
  daStartDate: string
  daEndDate: string
  rowid: string
  dtEndUTC?: string
  dtStartUTC?: string
}

export interface LotResponseImage {
  iImageNo: number
  sServer: string
  sPath: string
  image_url: string
  lPrimary: boolean
  imageuses: LotResponseImageUses[]
  lot_grid_url: string
  lot_main_url: string
  video_list_url: string
  sCaption: string
  sCredit: string
}

export interface LotResponseImageUses {
  iImageNo_id: number
  iImageUseNo: number
  sImageUse: EImageTypes
  sURLParams: string
}

export interface LotResponseSaleInfo {
  sDepartment: string
  related_departments: LotResponseSaleInfoRelatedItem[]
  sale_sections: LotResponseSaleInfoSaleSection[]
  conditions_of_sale: LotResponseSaleInfoConditionsOfSale
  snippets: LotResponseSaleInfoSnippets
}

export interface LotResponseSaleInfoRelatedItem {
  iDepartmentNo: number
  depimages: unknown[]
  depsnippets: unknown[]
  iDepartmentType: number
  iDepartmentStatus: number
  sDepartment: string
  sDepartmentName: string
  sTelNo: string
  sEmail: string
  sGroupDepartment: string
  sGLCostCentre: string
  lPublic: boolean
  iGroupOrder: number
  iOrder: number
}

export interface LotResponseSaleInfoSaleSection {
  iSaleSectionNoUnique: number
  iSaleSectionNo: number
  sSaleSectionName: string
  iSaleNo: number
  dtStartUTC: string
  min_lot: number
  division_start: string
  division_end: string | null
  division_tz: string
  timezone?: string
}

export interface LotResponseSaleInfoConditionsOfSale {
  image_url: string | null
}

export interface LotResponseSaleInfoSnippets {
  auction_information: unknown
  body: string
  all_special_notices: LotResponseSaleInfoSnippetsNotice[]
}

export interface LotResponseSaleInfoSnippetsNotice {
  notice_type: string
  text: string
  notice_type_id: string
}

export interface LotResponsePrevNextLot {
  is_preview_lot: boolean
  next_lot: LotResponsePrevNextLotDetails | null
  prev_lot: LotResponsePrevNextLotDetails | null
}

export interface LotResponsePrevNextLotDetails {
  id: string
  desc: string
  slug: string
}

export enum LotImageTypes {
  main = 'MAIN',
  carousel = 'CAROUSEL',
  cover = 'COVER',
  catalog = 'CATALOG',
  thumb = 'THUMB',
}

export type EImageTypes = `${LotImageTypes}`
